import CognitoProvider from './cognitoProvider'

export default function (ctx) {
    return new CognitoProvider(ctx)
}
